module.exports = __webpack_public_path__ + "img/c04_unittechramshipchampion_Normal_ua.a62e2dc6.webp";